<template>
  <modal
    :show.sync="showExtrasModal"
    modal-classes="modal-dialog-centered modal-lg"
    body-classes
    @close="hideModalFromButtonClose()"
    no-close-on-backdrop
  >
    <template slot="header">
      <h5 class="subtitle" id="modalcolumns">Manage Extra Charges</h5>
    </template>

    <div class="row align-items-center mt-3 forms">
      <div class="col-6"></div>
      <div class="col-6 text-right">
        <base-button
          type="link"
          class="min-button p-0 mb-3"
          @click="addExtras()"
        >
          <i class="flaticon-plus"></i> Add More
        </base-button>
      </div>

      <div class="col-12">
        <div class="rows-extra" id="rows-extra" v-show="localExtras.length > 0">
          <div
            class="row"
            v-for="(item, index) in $v.localExtras.$each.$iter"
            :key="index"
          >
            <div class="col-xl-5 col-lg-5 col-md-12 col-sm-12 col-12 pr-0">
              <WSelect
                v-model="item.description.$model"
                label="Description"
                placeholder=""
                filterable
                clearable
                :error="item.description.$error ? 'Select an Description' : ''"
                markrequired
              >
                <el-option
                  v-for="(item, index) in extraCharges"
                  :value="item.name"
                  :label="item.name"
                  :key="index"
                ></el-option>
              </WSelect>
            </div>

            <div
              class="col-xl-3 col-lg-3 col-md-5 col-sm-5 col-5 pr-0 align-self-center"
            >
              <BaseNumberInput
                v-model.number="item.net_price.$model"
                label="Net Price"
                placeholder="Net Price"
                class="input-append with-prepend"
                @input="getGroosPrice(item)"
                :error="item.net_price.$error ? `Enter a Price` : ''"
                :tooltip="true"
                titleTooltip="<strong>Net Price:</strong>"
                contentTooltip="<span>The net amount represents the value specified by the supplier for any additional charges. For instance, if an supplier indicates there will be an extra fee for extended time, that fee constitutes the net amount. This value can only be zero if the additional charge does not pertain to the supplier.</span>"
                markrequired
              >
                <template slot="prepend">{{ currency.symbol }}</template>
                <template slot="append">{{ currency.code }}</template>
              </BaseNumberInput>
            </div>

            <div
              class="col-xl-3 col-lg-3 col-md-5 col-sm-5 col-5 pr-0 align-self-center"
            >
              <BaseNumberInput
                v-model.number="item.gross_price.$model"
                label="Gross Price"
                placeholder="Gross Price"
                class="input-append with-prepend"
                :error="item.gross_price.$error ? `Enter a Price` : ''"
                :tooltip="true"
                titleTooltip="<strong>Gross Price:</strong>"
                contentTooltip="<span>The total amount to be charged to the customer, reflecting the assigned markup. This value updates whenever the net price is modified. The gross price can be zero if no charge will be applied to the customer.</span>"
                markrequired
              >
                <template slot="prepend">{{ currency.symbol }}</template>
                <template slot="append">{{ currency.code }}</template>
              </BaseNumberInput>
            </div>

            <div
              class="col-xl-1 col-lg-1 col-md-2 col-sm-2 col-2 pr-0 align-self-center"
            >
              <el-tooltip content="Delete" placement="bottom">
                <span class="icon-action mb-4" @click="deleteExtras(index)">
                  <i class="flaticon-delete text-danger"></i>
                </span>
              </el-tooltip>
            </div>
          </div>
        </div>
        <base-alert
          v-show="localExtras.length === 0"
          type="warning"
          class="info-min"
        >
          <i class="flaticon-warning mr-1"></i>
          There are currently no extras added.
        </base-alert>
      </div>
    </div>

    <template slot="footer">
      <base-button
        type="outline-neutral "
        class="min-button mb-0"
        @click="hideModalFromButtonCancel()"
        >Cancel</base-button
      >
      <base-button
        type="primary"
        class="min-button ml-auto mb-0"
        @click="saveExtraS()"
        >Accept</base-button
      >
    </template>
  </modal>
</template>

<script>
// @ is an alias to /src
import WSelect from "@/components/Select";
import {
  required,
  minLength,
  maxLength,
  decimal,
  minValue
} from "vuelidate/lib/validators";
import Swal from "sweetalert2";
import lodash from "lodash";
WSelect.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};

export default {
  name: "ManageExtras",
  components: {
    WSelect
  },
  props: {
    show: {
      type: Boolean,
      required: true
    },
    markUp: {
      type: Number,
      required: true
    },
    markUpType: {
      type: String,
      required: true
    },
    extras: {
      type: Array,
      required: true
    },
    currency: {
      code: {
        type: String,
        default: "EUR",
        description: ""
      },
      symbol: {
        type: String,
        default: "€",
        description: ""
      }
    }
  },
  watch: {
    show: {
      handler: function(current, old) {
        this.showExtrasModal = current;
      },
      deep: true
    },
    extras: {
      handler: function(current, old) {
        this.localExtras = lodash.cloneDeep(current);
        this.copyLocalExtras = lodash.cloneDeep(current);
      },
      deep: true
    },
    markUpType: {
      handler: function(current, old) {
        this.localMarkUpType = current;
      },
      deep: true
    },
    markUp: {
      handler: function(current, old) {
        this.localMarkUp = current;
      },
      deep: true
    }
  },
  data() {
    return {
      showExtrasModal: false,
      extraCharges: [
        { name: "Alcoholic Beverages" },
        { name: "Bilingual Driver" },
        { name: "Child Seats" },
        { name: "Cleaning Fee" },
        { name: "Driver wait time/Extra hours" },
        { name: "Excess luggage/Vehicle change" },
        { name: "Multiple pick up/Drop off points" },
        { name: "Night Fees" },
        { name: "Non Alcoholic Beverages" },
        { name: "Other" },
        { name: "Out-of-zone pick up/Drop off" },
        { name: "Parking fee" },
        { name: "Passenger escort to hotel" },
        { name: "Pet Fee" },
        { name: "Surcharge" },
        { name: "Toll Fees" }
      ],
      localExtras: [],
      copyLocalExtras: [],
      localMarkUpType: "",
      localMarkUp: 0,
      limitExtras: 14
    };
  },
  async created() {
    this.localMarkUpType = this.markUpType;
    this.localMarkUp = this.markUp;
    this.localExtras = lodash.cloneDeep(this.extras);
    this.copyLocalExtras = lodash.cloneDeep(this.extras);
  },
  methods: {
    deleteExtras(index) {
      this.localExtras.splice(index, 1);
    },
    addExtras() {
      if (this.localExtras.length < this.limitExtras) {
        this.localExtras.push({
          description: "",
          net_price: 0,
          gross_price: 0,
          paymentStatus: "UNPAID",
          paymentId: null,
          payment: null
        });
      } else {
        this.$notify({
          type: "warning",
          title: "Important!",
          message: "The allowable limit was exceeded",
          icon: "flaticon-warning-1"
        });
      }
    },
    saveExtraS() {
      if (!this.$v.localExtras.$invalid) {
        if (!this.hasDuplicates(this.localExtras)) {
          this.$emit("change", this.$v.localExtras.$model);
        } else {
          this.$notify({
            type: "warning",
            title: "Duplicate!",
            message: "There is one more duplicate item",
            icon: "flaticon-warning-1"
          });
        }
      } else {
        this.$v.localExtras.$touch();
        this.$notify({
          type: "warning",
          title: "Important!",
          message: "Please complete the required attributes",
          icon: "flaticon-warning-1"
        });
      }
    },
    closeExtrasModal() {
      this.showExtrasModal = false;
      this.$emit("close", false);
    },
    async hideModalFromButtonClose() {
      this.showExtrasModal = true;
      await this.detectChanges();
    },
    async hideModalFromButtonCancel() {
      await this.detectChanges();
    },
    async detectChanges() {
      let isEqual = lodash.isEqual(this.localExtras, this.copyLocalExtras);
      if (!isEqual) {
        let { value } = await Swal.fire({
          title: "Important",
          html:
            "The Extras has been modified. <br> Do you want to save changes?",
          imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
          buttonsStyling: false,
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          allowOutsideClick: false,
          reverseButtons: true,
          cancelButtonText: "No",

          confirmButtonText: "Yes",
          confirmButtonClass: "btn btn-primary btn-small-one"
        });
        if (value) {
          this.saveExtraS();
        } else {
          this.localExtras = lodash.cloneDeep(this.copyLocalExtras);
          this.closeExtrasModal();
        }
      } else {
        this.closeExtrasModal();
      }
    },
    getGroosPrice(item) {
      let grossPrice =
        this.localMarkUpType === "markup"
          ? item.net_price.$model / (1 - this.localMarkUp / 100)
          : item.net_price.$model * (1 - this.localMarkUp / 100);
      item.gross_price.$model = parseFloat(grossPrice.toFixed(2));
    },
    hasDuplicates(extras = []) {
      let descriptions = new Set();
      for (let extra of extras) {
        if (descriptions.has(extra.description)) {
          return true;
        } else {
          descriptions.add(extra.description);
        }
      }
      return false;
    }
  },
  validations: {
    localExtras: {
      $each: {
        description: {
          required,
          minLength: minLength(5),
          maxLength: maxLength(50)
        },
        net_price: {
          required,
          decimal,
          customValidator: function(value, context) {
            return context.gross_price > 0 || value > 0;
          }
        },
        gross_price: {
          required,
          decimal,
          customValidator: function(value, context) {
            return context.net_price > 0 || value > 0;
          }
        }
      }
    }
  }
};
</script>
